var map = {
	"./nb": 386,
	"./nb.js": 386
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1177;



/*****************
 ** WEBPACK FOOTER
 ** ./~/moment/locale nb
 ** module id = 1177
 ** module chunks = 1
 **/